export const environment = {
  production: true,
  BaseURL: "https://api.collectxapp.com/api/v1/admin/",
  TemplateUrl:"https://api.collectxapp.com/",
  recaptchaSiteKey: "6LfFkEctAAAAAMYi0_03tkpc7RWJ_Gskik8i00vI",
  captchaEnabled: true
};
